import { FundriseRouteConfig, NavigationGuard } from 'vue-router';
import { AxiosError } from 'axios';
import { getReferralByKey } from '@api/referral';
import { isValidSlug } from '@utils/routing';
import { useAppStore } from '@stores/app';

const referralNavigationGuard: NavigationGuard = async (to) => {
	try {
		const inviteKey = (to.params.inviteKey || to.query.i) as string;
		if (!inviteKey) {
			return { name: 'referral-welcome' };
		}

		if (!isValidSlug(inviteKey)) {
			return { name: '404' };
		}

		const referrerUser = await getReferralByKey(inviteKey);
		if (referrerUser) {
			let referralCampaign = 'investor-invitation';

			if (to.name === 'ios-invitation-redirect') {
				referralCampaign = 'investor-invitation-app';
			} else if (to.name === 'android-invitation-redirect') {
				referralCampaign = 'investor-invitation-android';
			}

			return {
				name: 'referral-welcome',
				query: {
					inviteKey,
					utm_campaign: referralCampaign,
					utm_medium: 'invite-link',
					utm_source: 'fundrise'
				}
			};
		} else {
			return { name: 'referral-welcome' };
		}
	} catch (error: unknown) {
		const e = error as AxiosError;
		if (e.response?.status === 400) {
			const appStore = useAppStore();
			appStore.addToast({
				type: 'error',
				message: 'Invalid invite link'
			});
		}
		return { name: 'home' };
	}
};

const referralRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/r/:inviteKey?',
		name: 'web-invitation-redirect',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: referralNavigationGuard,
		// revisit using redirect
		component: () => import('@views/marketing-site/home-view.vue')
	},
	{
		path: '/i/:inviteKey?',
		name: 'ios-invitation-redirect',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: referralNavigationGuard,
		// revisit using redirect
		component: () => import('@views/marketing-site/home-view.vue')
	},
	{
		path: '/a/:inviteKey?',
		name: 'android-invitation-redirect',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: referralNavigationGuard,
		// revisit using redirect
		component: () => import('@views/marketing-site/home-view.vue')
	}
];

export default referralRoutes;
